
Checkout.Login = function(checkout) {
	var login;
    var checkoutLogin = this;

    this.login = login;
	this.saved = true;
	this.lookup = false;

	this.init = function() {
        login = new Login("#loginwrapper");
		// if we are soft logged in, pre-fill the email address on the login form
		if (checkout.session && checkout.session.get('softLoggedIn') &&
		    checkout.session.get('billing') && checkout.session.get('billing').email && login.$email) {
			login.$email.val( checkout.session.get('billing').email );
			login.$password.val('');
		}

        login.callbacks = {
            'submit' : {
                'done' : function(response) {
                    checkout.session.load(response.data);
                    // on login, reset listrak cart, so cart reaches listrak for logged in
                    // user 
                    if (checkout.cart && checkout.cart.listrakItemsString) 
                        checkout.cart.listrakItemsString = "";
                    if (response.data.refreshCart) {
                        checkout.cart.checkItems(true, true);
                    } else {
                        checkout.cart.checkItems();
                    }
                    checkoutLogin.proceed();
                }
            }
        };

        checkoutLogin.listen();

		if (
			checkout.billship
			|| checkout.session.isLoggedIn()
			|| checkout.session.get('PayPalConfirmed')
		) {
			checkoutLogin.proceed();
			return;
		}

		checkoutLogin.lookup = new Checkout.Login.Lookup(checkout, checkoutLogin);

		login.$wrap.show();

        checkoutLogin.$wrap   = login.$wrap;
        checkoutLogin.$anchor = login.$anchor;
        checkoutLogin.login   = login;

		$('html,body').animate(
			{ 'scrollTop': login.$anchor.offset().top },
			500
		);
	};

	this.listen = function() {
		login.$createAccount.click(checkoutLogin.createAccount);

		checkout.cart.$wrap.on('loadFail', function(e) {
			login.$wrap.hide();
		});
	};

	this.proceed = function() {

		login.$wrap.hide();
		
		if (checkout.config.saveForLater) {
			checkout.cart.saveForLater.syncWishList();
		}

		if (!checkout.billship)
			checkout.billship = new Checkout.BillShip(checkout);

		checkout.billship.buildContent();
		checkout.billship.stepTo();
	};

	this.createAccount = function() {
		checkoutLogin.proceed();
	};

	this.init();
};

